import classname from 'classnames/bind'
import { Text, constants } from '@adc/ui-adc'
import styles from './styles.scss'
const { ColorNames } = constants
const cx = classname.bind(styles)
interface StepData {
  icon: string
  title: string | JSX.Element
  description: string
}
const ClaimStep = ({ icon, title, description }: StepData) => {
  return (
    <div className={cx('claim-section')}>
      <div className={cx('icon-container')}>
        <img src={icon} />
      </div>
      <div className={cx('text-content')}>
        <Text
          style={{ lineHeight: '28px' }}
          className={cx('text-title')}
          weight='medium'
          size='big'
          color={ColorNames.Action}
          as={'h3'}
        >
          {title}
        </Text>
        <Text
          className={cx('text-description')}
          color={ColorNames.Gray}
          size='small'
          weight='normal'
          style={{ lineHeight: '26px' }}
        >
          {description}
        </Text>
      </div>
    </div>
  )
}

export default ClaimStep
